module.exports = __webpack_public_path__ + "static/media/masters_thesis17.971b3dde.webp";